import { render } from "./tuesday-morning.vue?vue&type=template&id=4d412dc4"
import script from "./tuesday-morning.vue?vue&type=script&lang=js"
export * from "./tuesday-morning.vue?vue&type=script&lang=js"
script.render = render

export default script